<template>
  <div id="base_footer">
    <footer class="footer_title">
      <p>Copyrights ©2019 All Rights Reserved by Top-Link.</p>
      <div class="phone">
          <p><i class="fa fa-phone fa-2x" aria-hidden="true"></i></p>
          <p>02-2759-7167</p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'baseFooter',
  jsonld:{
    "@context": "http://schema.org/",
    "@type": "Organization",
    "name": "???? | TopLink ??????????",
    "description": "???? | TopLink ??????????",
    "url": "https://member.top-link.com.tw"
  }
}
</script>
<style>
  .footer_title{
    width: 100%;
    height: 77px;
    background-color: #313131;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .footer_title .phone{ display: flex; justify-content: center; align-items: center;}
  .footer_title .phone p{ font-size: 17px; margin-left: 9px;}
  .footer_title p{
    font-weight: bold;
  }
  .footer_title>p:nth-child(1){ margin-right: 5px; text-align: center;}
  @media(max-width: 768px){
    .footer_title{flex-direction: column; height: auto;}
  }
</style>